/**
 * What cTrader tells us at launch, from the query string it appends:
 *   placement  asp_t | asp_b | tw_t | wl_bs | custom_w …   where the plugin was opened
 *   platform   web | ios | android | windows | mac
 *   theme      light | dark        lang   ui language        id   the plugin id
 *   symbol     e.g. XAUUSD — in the Active Symbol Panel placements, what the trader is looking at
 *
 * `framed` alone does not say whether a host exists: native apps put the plugin in a TOP-LEVEL
 * webview and bridge the SDK's window events, so `framed: false` on ios/android still has a host.
 * The one dead case is a browser top-level window (the separate-window placement), where nothing
 * bridges anything. See docs/07-webview-spike.md.
 */
export interface LaunchEnv {
  readonly placement: string
  readonly platform: string
  readonly theme: 'light' | 'dark' | 'system'
  readonly lang: string
  readonly symbol: string | null
  readonly framed: boolean
  readonly hasHost: boolean
  /** The mobile bottom sheet is the binding layout: 390 px wide. */
  readonly narrow: boolean
}

export function readLaunchEnv(
  search: string = window.location.search,
  framed: boolean = window !== window.parent,
  width: number = window.innerWidth,
): LaunchEnv {
  const params = new URLSearchParams(search)
  const platform = params.get('platform') ?? ''
  const nativeHost = ['ios', 'android', 'windows', 'mac'].includes(platform)
  const theme = params.get('theme')
  return {
    placement: params.get('placement') ?? '',
    platform,
    theme: theme === 'dark' || theme === 'light' ? theme : 'system',
    lang: params.get('lang') ?? 'en',
    symbol: params.get('symbol'),
    framed,
    hasHost: framed || nativeHost,
    narrow: width < 480,
  }
}

/** The origin's API prefix — Caddy strips it before the API sees the path. */
export const API_BASE = '/api'
